import { CustomButton, CustomInputSelect } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import UsersProfileModuleOptionDatatableHandler from '../containers/datatables/UsersProfileModuleOptionDatatableHandler/UsersProfileModuleOptionDatatableHandler';

export default function ProfileOptionModule() {
  return (
    <>
      <CC.Box>
        <CC.Flex flexDirection={{ base: 'column', md: 'row' }}>
          <CustomFormControl label="Profile">
            <CustomInputSelect
              meta={{
                name: 'profile',
                options: [{ label: 'Paul Biya', value: 'paul-biya' }],
              }}
            />
          </CustomFormControl>

          <CustomFormControl
            label="Banque"
            mx={{ base: 0, md: 2 }}
            mt={{ base: 2, md: 0 }}
          >
            <CustomInputSelect
              meta={{
                name: 'profile',
                options: [{ label: 'Eco Bank', value: 'eco-bank' }],
              }}
            />
          </CustomFormControl>

          <CustomFormControl label="Agence" mt={{ base: 2, md: 0 }}>
            <CustomInputSelect
              meta={{
                name: 'profile',
                options: [{ label: 'Agence1', value: 'agence1' }],
              }}
            />
          </CustomFormControl>
        </CC.Flex>
        <CC.Flex>
          <CustomFormControl label="Module" my="4">
            <CustomInputSelect
              meta={{
                name: 'module',
                options: [
                  {
                    label: 'Gestion des utilisateurs',
                    value: 'users-management',
                  },
                ],
              }}
            />
          </CustomFormControl>
        </CC.Flex>

        <CC.Flex justifyContent="flex-end">
          <CustomButton>Afficher</CustomButton>
        </CC.Flex>

        <CC.Flex w="full" my="4">
          <UsersProfileModuleOptionDatatableHandler />
        </CC.Flex>
      </CC.Box>
    </>
  );
}
